import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Progress,
  CardImg,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { api } from "../../../api";
import Cookies from "js-cookie";
import defaultProfile from "../../images/default-profile.png";

// Add the goodMessageStyle constant at the top of the file
const goodMessageStyle = `
.good-message {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #d86f89;
  color: #222;
  font-weight: bold;
  font-size: 1.2rem;
  border-radius: 10px;
  padding: 0.5em 1.5em;
  margin: 0 auto;
  white-space: nowrap;
  max-width: 100vw;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
`;

// Add this style block after goodMessageStyle
const calendarCustomStyle = `
.react-calendar__tile--active,
.react-calendar__tile--range,
.react-calendar__tile--rangeStart,
.react-calendar__tile--rangeEnd {
  background: #d86f89 !important;
  color: #fff !important;
}
`;

const getImagePath = (imageName) => {
  const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
  if (!imageName) return isProduction ? '/images/default-profile.png' : '/dashboard/images/default-profile.png';
  try {
    const decodedImageName = decodeURIComponent(imageName);
    return isProduction ? `/images/${decodedImageName}` : require(`./../../images/${decodedImageName}`);
  } catch (error) {
    return isProduction ? '/images/default-profile.png' : '/dashboard/images/default-profile.png';
  }
};

const Dashboard = () => {
  const [date, setDate] = useState(new Date());
  const [selectedDateLabel, setSelectedDateLabel] = useState("");
  const [isBirthday, setIsBirthday] = useState(false);
  const [timeOfDay, setTimeOfDay] = useState("");
  const getFormattedDateLabel = (date) => {
    return `${date.toLocaleString("default", {
      month: "long",
    })} ${date.getDate()}, ${date.getFullYear()}`;
  };
  useEffect(() => {
    setSelectedDateLabel(getFormattedDateLabel(date));
  }, [date]);

  const checkBirthday = (date) => {
    return date.getMonth() === 0 && date.getDate() === 1;
  };

  const getTimeOfDay = (date) => {
    const hour = date.getHours();
    if (hour >= 0 && hour < 12) {
      return "Morning🌞";
    } else if (hour >= 12 && hour < 18) {
      return "Afternoon⛅";
    } else {
      return "Night🌙";
    }
  };

  useEffect(() => {
    const label = getFormattedDateLabel(date);
    setSelectedDateLabel(label);
    setIsBirthday(checkBirthday(date));
    setTimeOfDay(getTimeOfDay(date));
  }, [date]);

  const [progressPercentage, setProgressPercentage] = useState(75);

  const emp_id = Cookies.get("token");

  const [pcount, setPcount] = useState();
  const [projects, setproject] = useState([]);
  const [loading, setLoading] = useState(true);
  const [completedTasksCount, setCompletedTasksCount] = useState(0);
  const [countper, setcountper] = useState({
    pending: "",
    inprogress: "",
    completed: "",
  });
  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const emp_id = Cookies.get('emp_id') || Cookies.get('token');
        
        console.log("Dashboard - emp_id:", emp_id);
        console.log("Dashboard - company_id:", company_id);
        
        const response = await api.get(`projectDashboard.php?p_m_id=${emp_id}&company_id=${company_id}`);
        const response2 = await api.get(
          `viewProjectDetails.php?emp_id=${emp_id}&p_m_id=${emp_id}&company_id=${company_id}`
        );
        const response3 = await api.get(`viewTask.php?id=${emp_id}&company_id=${company_id}`);
        
        console.log("Dashboard - Project counts from API:", response.data);
        console.log("Dashboard - Projects assigned to user:", response2.data);
        console.log("Dashboard - Tasks data:", response3.data);
        
        setproject(response2.data);
        
        // Count completed tasks
        const tasks = Array.isArray(response3.data) ? response3.data : [];
        const completedTasks = tasks.filter(task => task.status === 'completed');
        setCompletedTasksCount(completedTasks.length);
        
        // Use the API data for counts (which is already filtered by user)
        const totalProjects = parseInt(response.data[0]?.totalProjects) || 0;
        const pendingProjects = parseInt(response.data[1]?.pendingProjects) || 0;
        const completedProjects = parseInt(response.data[2]?.completedProjects) || 0;
        const inProgressProjects = parseInt(response.data[3]?.inProgressProjects) || 0;
        
        setPcount(response.data);

        const result = totalProjects > 0 ? Math.floor((completedProjects / totalProjects) * 100) : 0;
        const result2 = totalProjects > 0 ? Math.floor((pendingProjects / totalProjects) * 100) : 0;
        const result3 = totalProjects > 0 ? Math.floor((inProgressProjects / totalProjects) * 100) : 0;
        
        const completedcount = isNaN(result) ? 0 : Math.floor(result);
        const pendingcount = isNaN(result2) ? 0 : Math.floor(result2);
        const inprogresscount = isNaN(result3) ? 0 : Math.floor(result3);

        console.log("Dashboard - Calculated percentages:", { completedcount, pendingcount, inprogresscount });
        console.log("Dashboard - API project counts:", { totalProjects, pendingProjects, completedProjects, inProgressProjects });
        
        setcountper({
          pending: pendingcount,
          inprogress: inprogresscount,
          completed: completedcount,
        });
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  console.log(projects);

  const [employees, setEmployees] = useState([]);
  const fetchEmployeeName = async () => {
    try {
      const company_id = Cookies.get('company_id');
      if (!company_id) {
        throw new Error('Missing company_id in cookies');
      }
      const response = await api.get(`employeeCalendar.php?company_id=${company_id}`);
      setEmployees(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchEmployeeName();
  }, []);

  useEffect(() => {
    const label = getFormattedDateLabel(date);
    setTimeOfDay(getTimeOfDay(date));
  }, [date, employees]);

  const isEmployeeBirthday = (date, employee) => {
    const employeeDOB = new Date(employee.dob);
    return (
      date.getDate() === employeeDOB.getDate() &&
      date.getMonth() === employeeDOB.getMonth()
    );
  };

  const isEmployeeWorkAnniversary = (date, employee) => {
    const anniversaryDate = new Date(employee.doj);
    return (
      date.getDate() === anniversaryDate.getDate() &&
      date.getMonth() === anniversaryDate.getMonth()
    );
  };

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        
        <Container fluid>
          <Row>
            {/* Total Projects Card */}
            <Col lg="6" xl="3">
              <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                }}
              >
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center">
                    <CardTitle className="h3 mb-0">Total Projects</CardTitle>
                    <span className="h2 font-weight-bold">
                      {pcount?.[0]?.totalProjects || "N/A"}
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* To Do Projects Card */}
            <Col lg="6" xl="3">
              <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                }}
              >
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center">
                    <CardTitle className="h3 mb-0">To Do Projects</CardTitle>
                    <span className="h2 font-weight-bold">
                      {pcount?.[1]?.pendingProjects || "N/A"}
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* Inprogress Projects Card */}
            <Col lg="6" xl="3">
              <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                }}
              >
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center">
                    <CardTitle className="h3 mb-0">
                      Inprogress Projects
                    </CardTitle>
                    <span className="h2 font-weight-bold">
                      {pcount?.[3]?.inProgressProjects || "N/A"}
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* Completed Tasks Card */}
            <Col lg="6" xl="3">
              <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                }}
              >
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center">
                    <CardTitle className="h3 mb-0">Completed Tasks</CardTitle>
                    <span className="h2 font-weight-bold">
                      {completedTasksCount}
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row className="mt-5">
            <Col lg="7">
              {" "}
              {/* Adjust the column size to your preference */}
              {/* Your existing cards */}
              <Card
                className="card-stats mb-4 mb-xl-0 m-0"
                style={{
                  borderRadius: "15px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                }}
              >
                <CardBody>
                  <Row>
                    <Col className="d-flex align-items-start text-center">
                      <div className="h1"> Overview</div>
                    </Col>
                    {/* <img
                                                src={require('../../project-management/assets/img/brand/WebDesignLayout-ezgif.com-crop (1).gif')}
                                                style={{ height: '100px', width: '200px', transform: 'scaleX(-1)' }}
                                                // transform: 'scaleX(-1)', 
                                                alt="Reversed Image"
                                            /> */}
                  </Row>
                </CardBody>
              </Card>
              {Array.isArray(projects) && projects.length > 0 ? (
                projects.map((project) => (
                  <Card
                    key={project.projectId}
                    className="card-stats mb-4 mb-xl-0 p-2 mt-3"
                    style={{
                      borderRadius: "50px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                      backgroundColor: "#fff",
                    }}
                  >
                    <CardBody>
                      <Row>
                        {/* Circular Progress Bar on the Left */}
                        <Col xs="3" className="text-center">
                          <div style={{ width: "80px", height: "80px" }}>
                            <CircularProgressbar
                              value={project.progress}
                              text={`${project.progress}%`}
                              styles={buildStyles({
                                textColor: "blue",
                                pathColor: "#007bff",
                                trailColor: "#eee",
                              })}
                            />
                          </div>
                        </Col>

                        <Col xs="6" className="text-center">
                          <h3>{project.projectName}</h3>
                          <p>About: {project.description}</p>
                        </Col>

                        <Col xs="3" className="d-flex justify-content-end">
                          <div className="avatar-group d-flex">
                            {project.profile.images.map((image, index) => (
                              <div
                                className="avatar-group "
                                style={{ height: "40px", width: "25px" }}
                                key={index}
                              >
                                <a
                                  className="avatar avatar-sm "
                                  href="#pablo"
                                  id={`tooltip-${project.projectId}-${index}`} // Use project.projectId and index for unique IDs
                                  onClick={(e) => e.preventDefault()}
                                >
                                  <img
                                    alt={`Image ${index}`}
                                    className="rounded-circle"
                                    style={{ height: "35px", width: "35px" }}
                                    src={getImagePath(image)}
                                    onError={e => {
                                      e.target.onerror = null;
                                      e.target.src = window.location.hostname === 'localhost'
                                        ? '/dashboard/images/default-profile.png'
                                        : '/images/default-profile.png';
                                    }}
                                  />
                                </a>
                                <UncontrolledTooltip
                                  delay={0}
                                  target={`tooltip-${project.projectId}-${index}`}
                                >
                                  {project.profile.full_names[index]}
                                </UncontrolledTooltip>
                              </div>
                            ))}
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                ))
              ) : (
                <div className="mt-4" style={{ textAlign: "center" }}>
                  No projects available
                </div>
              )}
            </Col>
            <Col lg="5">
              <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                  padding: '1rem',
                  margin: 0,
                  width: '100%',
                  maxWidth: 420,
                  minWidth: 0,
                  alignSelf: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <CardBody style={{ padding: 0, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Row style={{ margin: 0, width: '100%', justifyContent: 'center' }}>
                    <div className="col" style={{ textAlign: 'center' }}>
                      <CardTitle
                        tag="h3"
                        className="text-uppercase text-muted mb-0"
                        style={{ marginBottom: '0.5rem' }}
                      >
                        Calendar
                      </CardTitle>
                    </div>
                  </Row>
                  <Row style={{ margin: 0, width: '100%', justifyContent: 'center' }}>
                    <Col className="col-auto mt-2" style={{ padding: 0, width: '100%', display: 'flex', justifyContent: 'center' }}>
                      <div style={{ width: '100%', maxWidth: 340, minWidth: 0, display: 'flex', justifyContent: 'center' }}>
                      <Calendar
                          style={{ width: '100%' }}
                        onChange={setDate}
                        value={date}
                      />
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-2" style={{ margin: 0, width: '100%', justifyContent: 'center' }}>
                    <Col style={{ padding: 0, textAlign: 'center' }}>
                      <p style={{ margin: '0.5rem 0' }}>Selected Date: {selectedDateLabel}</p>
                      {isBirthday && (
                        <div>
                          <Row style={{ justifyContent: 'center' }}>
                            <Col className="col-auto">
                              <img
                                src="path/to/birthday_image.jpg"
                                alt="Birthday"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  borderRadius: "50%",
                                }}
                              />
                            </Col>
                          </Row>
                        </div>
                      )}
                      <style>{goodMessageStyle}</style>
                      <style>{calendarCustomStyle}</style>
                      {timeOfDay && (
                        <div style={{ textAlign: 'center', marginTop: 12, display: 'flex', justifyContent: 'center', width: '100%' }}>
                          <div className="good-message">Good {timeOfDay}</div>
                        </div>
                      )}
                    </Col>
                  </Row>
                  {employees.some(
                    (employee) =>
                      isEmployeeBirthday(date, employee) ||
                      isEmployeeWorkAnniversary(date, employee)
                  ) && (
                    <>
                      {employees.map((employee, index) => {
                        if (
                          isEmployeeBirthday(date, employee) &&
                          isEmployeeWorkAnniversary(date, employee)
                        ) {
                          return (
                            <Row
                              key={index}
                              style={{
                                border: "2px solid #ddd",
                                borderRadius: "10px",
                                padding: "10px",
                                backgroundColor: "#fff",
                                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                marginBottom: "8px",
                                marginLeft: 0,
                                marginRight: 0,
                                justifyContent: 'center',
                              }}
                            >
                              <Col xs={3} className="text-center">
                                <img
                                  src={getImagePath(employee.profile_image)}
                                  alt="Birthday & Work Anniversary"
                                  style={{
                                    width: "60px",
                                    height: "60px",
                                    borderRadius: "50%",
                                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                  }}
                                />
                              </Col>
                              <Col>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    color: "#333",
                                    marginBottom: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  🎉Happy Birthday & Work Anniversary!🎉
                                </p>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    fontSize: "16px",
                                    color: "#666",
                                    marginBottom: "4px",
                                  }}
                                >
                                  {employee.emp_name}
                                </p>
                                <p
                                  style={{
                                    marginTop: "6px",
                                    fontSize: "14px",
                                    color: "#555",
                                    textAlign: "center",
                                  }}
                                >
                                  Double celebration! Wishing you a day filled with joy, laughter, and all the things you love.
                                </p>
                              </Col>
                            </Row>
                          );
                        } else if (isEmployeeBirthday(date, employee)) {
                          return (
                            <Row
                              key={index}
                              style={{
                                border: "2px solid #ddd",
                                borderRadius: "10px",
                                padding: "10px",
                                backgroundColor: "#fff",
                                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                marginBottom: "8px",
                                marginLeft: 0,
                                marginRight: 0,
                                justifyContent: 'center',
                              }}
                            >
                              <Col xs={3} className="text-center">
                                <img
                                  src={getImagePath(employee.profile_image)}
                                  alt="Birthday"
                                  style={{
                                    width: "60px",
                                    height: "60px",
                                    borderRadius: "50%",
                                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                  }}
                                />
                              </Col>
                              <Col>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    color: "#333",
                                    marginBottom: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  🎉Happy Birthday!🎉
                                </p>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    fontSize: "16px",
                                    color: "#666",
                                    marginBottom: "4px",
                                  }}
                                >
                                  {employee.emp_name}
                                </p>
                                <p
                                  style={{
                                    marginTop: "6px",
                                    fontSize: "14px",
                                    color: "#555",
                                    textAlign: "center",
                                  }}
                                >
                                  Wishing you a day filled with joy, laughter, and all the things you love!
                                </p>
                              </Col>
                            </Row>
                          );
                        } else if (isEmployeeWorkAnniversary(date, employee)) {
                          return (
                            <Row
                              key={index}
                              style={{
                                border: "2px solid #ddd",
                                borderRadius: "10px",
                                padding: "10px",
                                backgroundColor: "#fff",
                                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                marginBottom: "8px",
                                marginLeft: 0,
                                marginRight: 0,
                                justifyContent: 'center',
                              }}
                            >
                              <Col xs={3} className="text-center">
                                <img
                                  src={getImagePath(employee.profile_image)}
                                  alt="Work Anniversary"
                                  style={{
                                    width: "60px",
                                    height: "60px",
                                    borderRadius: "50%",
                                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                  }}
                                />
                              </Col>
                              <Col>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    color: "#333",
                                    marginBottom: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  🎉Congratulations on your work anniversary!🎉
                                </p>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    fontSize: "16px",
                                    color: "#666",
                                    marginBottom: "4px",
                                  }}
                                >
                                  {employee.emp_name}
                                </p>
                                <p
                                  style={{
                                    marginTop: "6px",
                                    fontSize: "14px",
                                    color: "#555",
                                    textAlign: "center",
                                  }}
                                >
                                  It's been a pleasure having you on the team. Your hard work and dedication are appreciated.
                                </p>
                              </Col>
                            </Row>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Dashboard;
